var map = {
	"./advCartDeliveryInfo.el.locale.json": 4615,
	"./advCartDeliveryInfo.en.locale.json": 8533,
	"./advCartDeliveryInfo.es.locale.json": 3136,
	"./advCartDeliveryInfo.it.locale.json": 2443,
	"./advCartDeliveryInfo.ru.locale.json": 6895,
	"./advCartDeliveryInfo.zh.locale.json": 2098
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9618;